import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Formik, Form } from 'formik';
import { ForgotPasswordData } from 'Types';
import ForgotPasswordForm, { forgotPasswordFormSchema } from 'Components/Forms/ForgotPasswordForm';
import { ValidateForm } from 'Utils/Forms';
import { useAuthWrapperContext } from 'Contexts/AuthWrapperContext';

type ForgotPasswordProps = {
  goToReset: () => void;
};

const ForgotPassword: React.FC<ForgotPasswordProps> = (props) => {
  const { goToReset } = props;

  const {
    pendingEmailOrPhone,
    pendingCountryAcronym: _pendingCountryAcronym,
    errors,
    forgotPassword: forgotPasswordContext,
    resendSignUpUsername,
    resetErrors,
  } = useAuthWrapperContext();

  React.useEffect(() => {
    if (pendingEmailOrPhone) {
      goToReset();
    }
  }, [pendingEmailOrPhone, goToReset]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '20px',
        marginBottom: '20px',
        ...textStyles,
      }}
    >
      {pendingEmailOrPhone && (
        <>
          <Typography
            sx={{
              margin: '20px',
            }}
            color="rgb(255,255,255,1.0)"
          >
            Your registration is pending. Check your email to verify.
            <br></br>
            (If you don't see an email, check your spam folder)
          </Typography>
          <Link
            sx={{
              textAlign: 'center' as const,
              cursor: 'pointer',
            }}
            onClick={() => {
              resendSignUpUsername(pendingEmailOrPhone || '');
            }}
          >
            Didn't get a link? Click here to resend.
          </Link>
        </>
      )}
      {/* {!pendingEmail && resetEmail && 
        <Box
          sx={{
            maxWidth: '600px'
          }}
        > 
          <Typography 
            sx={{
              margin: "10px"
            }}
            color="rgb(255,255,255,1.0)"
          >
            If your email is in our system, a password reset link has been delivered to your inbox. Check your email (and spam). This can take up to 10 minutes. :)
          </Typography> 
        </Box>
      } */}
      {!pendingEmailOrPhone && (
        <>
          <Box
            sx={{
              maxWidth: '400px',
              margin: '20px',
            }}
          >
            <Typography
              sx={{
                fontSize: '20px',
                color: 'rgb(255,255,255,1.0)',
              }}
            >
              Forgot Password?
            </Typography>
            <Typography
              sx={{
                marginTop: '10px',
                fontSize: '16px',
                color: 'rgb(255,255,255,1.0)',
                fontFamily: 'Lato',
              }}
            >
              Enter the email or phone number you used when you joined and we’ll send you a
              verification code.
            </Typography>
          </Box>
          <Formik
            initialValues={{
              emailOrPhone: '',
              countryAcronym: 'US',
              unknown: '',
            }}
            validate={(values: ForgotPasswordData) => {
              return ValidateForm(forgotPasswordFormSchema, values);
            }}
            onSubmit={async (values: ForgotPasswordData) => {
              await forgotPasswordContext({
                payload: {
                  emailOrPhone: values.emailOrPhone,
                  countryAcronym: values.countryAcronym || '',
                },
              });
            }}
            validateOnChange={false}
          >
            {(formikProps) => (
              <Form
                onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                  e.preventDefault();
                  resetErrors();
                  formikProps.handleSubmit(e);
                }}
              >
                <Box
                  sx={{
                    marginTop: '10px',
                    marginBottom: '10px',
                    width: { xs: 'min(92vw, 520px)', sm: '350px' },
                    maxWidth: { xs: 'min(92vw, 520px)', sm: '350px' },
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <ForgotPasswordForm
                    {...formikProps}
                    errors={{ ...errors, ...formikProps.errors }}
                  />
                </Box>
              </Form>
            )}
          </Formik>
        </>
      )}
      <Box></Box>
    </Box>
  );
};

const textStyles = {
  fontFamily: 'Lato',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: 'normal',
  letterSpacing: '0.16px',
};

export default ForgotPassword;
